/* eslint-disable react/no-array-index-key */
import { useCallback, useEffect, useState } from 'react';

import { Link, useHistory, useParams } from 'react-router-dom';

import { Title, Container } from './styles';

interface IMatchedRoute {
  path: string;
  breadcrumbName: string;
}

const Breadcrumb = () => {
  const history = useHistory();
  const params = useParams();
  const [currentLocation, setCurrentLocation] = useState<string>('');
  const [matchedRoutes, setMatchedRoutes] = useState<IMatchedRoute[]>();

  const { state }: any = history.location;

  const handleMatchRoutes = useCallback(
    (location: Location) => {
      const routes = [
        { path: '/users', breadcrumbName: 'Treinadores' },
        { path: '/users/details', breadcrumbName: 'DETALHES DO TREINADOR' },
        {
          path: `/users/details/${state?.professionalId}/students`,
          breadcrumbName: 'ALUNOS',
        },
        {
          path: `/users/details/${state?.currentContractId}/payments`,
          breadcrumbName: 'HISTÓRICO DE PAGAMENTO',
        },
        {
          path: `/users/details/student/${state?.user?.id}`,
          breadcrumbName: 'DETALHES DO ALUNO',
        },
        { path: '/ilab', breadcrumbName: 'I.LAB' },
        { path: '/ilab/methods', breadcrumbName: 'MET - LIBRARY' },
        { path: '/ilab/methods/details', breadcrumbName: 'DETALHES DO MÉTODO' },
        { path: '/ilab/methods/edit', breadcrumbName: 'EDITAR MÉTODO' },
        { path: '/ilab/exercises', breadcrumbName: 'EX - LIBRARY' },
        {
          path: '/ilab/exercises/list',
          breadcrumbName: 'Listagem de Exercícios',
        },
        { path: '/ilab/exercises/edit', breadcrumbName: 'EDITAR EXERCÍCIO' },
        { path: '/ilab/symbology', breadcrumbName: 'Simbologia' },
        {
          path: '/ilab/symbology/cadaster',
          breadcrumbName: 'CADASTRAR SIMBOLOGIA',
        },
        { path: '/ilab/symbology/edit', breadcrumbName: 'EDITAR SIMBOLOGIA' },
        { path: '/ilab/training-store', breadcrumbName: 'TRANING STORE ' },
        { path: '/iboss', breadcrumbName: 'I.BOSS' },
        { path: '/iboss/trainer-charts', breadcrumbName: 'CRM - TREINADORES' },
        { path: '/iboss/student-charts', breadcrumbName: 'CRM - ALUNOS' },
        { path: '/iboss/finance-charts', breadcrumbName: 'CRM - FATURAMENTOS' },
        { path: '/collaborators', breadcrumbName: 'COLABORADORES' },
        { path: '/collaborators/cadaster', breadcrumbName: 'COLABORADORES' },
        { path: '/billing', breadcrumbName: 'FATURAMENTO' },
        { path: '/billing/comercial-plan', breadcrumbName: 'PLANO COMERCIAL' },
        { path: '/billing/payment-form', breadcrumbName: 'FORMA DE PAGAMENTO' },
        { path: '/billing/finance', breadcrumbName: 'HISTÓRICO FINANCEIRO' },
        { path: '/billing/status', breadcrumbName: 'STATUS FINANCEIRO' },
        { path: '/reports', breadcrumbName: 'RELATÓRIOS' },
      ];
      setCurrentLocation(location.pathname);
      const foundRoutes: IMatchedRoute[] = [];
      routes.forEach((route) => {
        const found = location.pathname.includes(route.path);
        if (found) {
          foundRoutes.push(route);
        }
      });
      setMatchedRoutes(foundRoutes);
    },
    [state?.currentContractId, state?.professionalId, state?.user?.id],
  );

  useEffect(() => {
    handleMatchRoutes((history.location as unknown) as Location);
  }, [handleMatchRoutes, history.location]);

  useEffect(() => {
    return history.listen((location) => {
      handleMatchRoutes((location as unknown) as Location);
    });
  }, [handleMatchRoutes, history, matchedRoutes]);

  return (
    <nav>
      <Container>
        {matchedRoutes?.map((data, index) => {
          const organizedRoutesByLength = matchedRoutes
            .flatMap((elem, i) => {
              if (i <= index) {
                if (
                  elem.path.includes('details') ||
                  elem.path.includes('edit') ||
                  elem.path.includes('list')
                ) {
                  return currentLocation;
                }
                return elem?.path;
              }
              return [];
            })
            .join('');

          const splitedOrganizedRoutes = organizedRoutesByLength.split('/');
          // Remove as duplicatas devido a organização das rotas
          const resultRoute = splitedOrganizedRoutes
            .filter((item, pos) => {
              return splitedOrganizedRoutes.indexOf(item) === pos;
            })
            .join('/');

          const isActive = resultRoute === currentLocation;

          return (
            <li key={index} style={{ opacity: !isActive ? 0.35 : 1.0 }}>
              <Link
                to={resultRoute}
                style={{ pointerEvents: isActive ? 'none' : 'all' }}
              >
                <Title>
                  {data?.breadcrumbName.concat(
                    index !== matchedRoutes.length - 1 ? ' >' : '',
                  )}
                </Title>
              </Link>
            </li>
          );
        })}
      </Container>
    </nav>
  );
};

export default Breadcrumb;
